/**
 * Performance Monitor Hook
 * 
 * Automatically log telemetry reports periodically
 */

import { useEffect } from 'react';
import { telemetry } from './telemetry';

/**
 * Hook to automatically log telemetry report and send to server
 */
export function usePerformanceMonitor(intervalMs: number = 60000) {
  useEffect(() => {
    const interval = setInterval(async () => {
      const report = telemetry.generateReport();
      
      if (report.marks.length > 0) {
        telemetry.logReport();
        
        // Send to analytics endpoint (server-side)
        try {
          await telemetry.sendReport('/api/analytics/performance');
          console.log('✅ Telemetry report exported successfully');
          
          // Clear marks after successful export to avoid duplicate reports
          telemetry.clear();
        } catch (error) {
          console.error('❌ Failed to export telemetry:', error);
          // Keep marks for next attempt
        }
      }
    }, intervalMs);

    return () => clearInterval(interval);
  }, [intervalMs]);
}

/**
 * Log telemetry on page unload
 */
export function setupUnloadTelemetry() {
  if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', () => {
      const report = telemetry.generateReport();
      
      if (report.marks.length > 0) {
        console.log('📊 Final telemetry report before unload:');
        telemetry.logReport();
        
        // Save to localStorage for debugging
        try {
          localStorage.setItem('last-telemetry-report', telemetry.exportReport());
        } catch (e) {
          console.error('Failed to save telemetry report:', e);
        }
      }
    });
  }
}
